// Storefront <img> tags render the WebP variants (~33 KB vs ~1.2 MB for
// the source PNGs — a 35x cut that Lighthouse mobile scoring hinges on).
// The .png URLs stay canonical in the DB/emails/Open Graph tags where
// scraper compatibility matters; only local /bottles/ paths are swapped.
export const toWebp = (url) =>
  url && url.startsWith("/bottles/") && url.endsWith(".png")
    ? url.replace(/\.png$/, ".webp")
    : url;

// AVIF variants (~4.7 KB, quality 10) are the primary storefront format.
// SafeImage auto-downgrades .avif → .webp when the browser can't decode it.
export const toAvif = (url) =>
  url && url.startsWith("/bottles/") && url.endsWith(".png")
    ? url.replace(/\.png$/, ".avif")
    : url;

export const IMAGES = {
  "reta-10mg": "/bottles/reta-10mg.png",
  "reta-15mg": "/bottles/reta-15mg.png",
  "reta-20mg": "/bottles/reta-20mg.png",
  "reta-40mg": "/bottles/reta-40mg.png",
  "reta-60mg": "/bottles/reta-60mg.png",
  "reta-80mg": "/bottles/reta-80mg.png",
  "reta-100mg": "/bottles/reta-100mg.png",
  "reta-150mg": "/bottles/reta-150mg.png",
  "bac-water-10ml": "/bottles/bacteriostatic-water-10ml.png",
  // Home/About hero default — Retatrutide 20mg per design direction
  hero: "/bottles/reta-20mg.png",
};

// Fallback static catalog used while backend loads. Auto-generated from the
// live published catalog by `scripts/sync-static-catalog.js` (runs as the
// yarn `prebuild` step on every deploy, and can be run manually). Keeping it
// in sync prevents a visible product/price swap — and an unstable LCP
// element — when the /api/products response replaces the first paint.
import staticCatalog from "./staticCatalog.json";

export const STATIC_PRODUCTS = staticCatalog;
